export default __webpack_public_path__ + "static/media/Beard_4_C4.24bf4c38.svg";